import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';
import { LivemodeFilterValidationSchema } from '../shared/livemode';
import { InvoiceResponseValidationSchema } from './response';

export const GetInvoicePathParamsValidationSchema = z.object({
  id: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the invoice to retrieve. Use `list_invoices` first if you need to discover the invoice ID by customer email, customer name, invoice number, PO number, or the payment it belongs to (`chargeId`).',
  }),
});

// The API parses its path params with the schema above, so livemode goes on the MCP input only.
export const GetInvoiceInputValidationSchema = GetInvoicePathParamsValidationSchema.extend({
  livemode: LivemodeFilterValidationSchema,
});

export const GetInvoiceResponseValidationSchema = z.object({
  data: InvoiceResponseValidationSchema,
});
